var borderCache = {}

export function messyBorderStyle(cache_id) {

    if (!borderCache[cache_id]) {
        const options = ['15px 255px', '255px 15px', '10px 10px'];

        var result = {
            borderBottomRightRadius: options[Math.floor(Math.random() * 2)],
            borderTopRightRadius: options[Math.floor(Math.random() * 2)],
            borderTopLeftRadius: options[Math.floor(Math.random() * 2)],
            borderBottomLeftRadius: options[Math.floor(Math.random() * 2)],
        }

        while (result.borderBottomLeftRadius === result.borderBottomRightRadius
            && result.borderBottomLeftRadius === result.borderTopLeftRadius
            && result.borderBottomLeftRadius === result.borderTopRightRadius) {
            result = {
                borderBottomRightRadius: options[Math.floor(Math.random() * 2)],
                borderTopRightRadius: options[Math.floor(Math.random() * 2)],
                borderTopLeftRadius: options[Math.floor(Math.random() * 2)],
                borderBottomLeftRadius: options[Math.floor(Math.random() * 2)],
            }
        }
        borderCache[cache_id] = result;
    }

    return borderCache[cache_id]
}